export default __webpack_public_path__ + "static/media/location.c458aa44.svg";